import { render, staticRenderFns } from "./investor-footer.vue?vue&type=template&id=5e76ee61&scoped=true&"
import script from "./investor-footer.vue?vue&type=script&lang=js&"
export * from "./investor-footer.vue?vue&type=script&lang=js&"
import style0 from "./investor-footer.vue?vue&type=style&index=0&id=5e76ee61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e76ee61",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
